module.exports = __webpack_public_path__ + "static/img/mikrofon.f65a898.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/urzadzenia/mikrofon.svg
// module id = iQyx
// module chunks = 1